var map = {
	"./alerts_black.svg": "3682",
	"./calendar_black.svg": "580e",
	"./conflict_black.svg": "69c6",
	"./crime_black.svg": "88d5",
	"./disasters_black.svg": "31c0",
	"./elections_black.svg": "924f",
	"./events_black.svg": "2abb",
	"./health_black.svg": "8e17",
	"./layers_black.svg": "bb01",
	"./media_black.svg": "1017",
	"./person_black.svg": "2b97",
	"./places2_black.svg": "bb82",
	"./places_black.svg": "fba8",
	"./political_terrorism_black.svg": "4e6b",
	"./profile_black.svg": "038f",
	"./pulse_black.svg": "f75e",
	"./terrorism_black.svg": "ee41",
	"./transportation_black.svg": "1817",
	"./travel_black.svg": "6ece",
	"./unrest_black.svg": "1ef5",
	"./war_black.svg": "3511"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8b6e";